import React from 'react';
import withIcon from '../utilities/withIcon';

const IconCircle = () => {
  return (
    <g>
      <path d="m8 15.8574a7.8574 7.8574 0 1 1 7.8572-7.8574 7.8661 7.8661 0 0 1 -7.8572 7.8574zm0-14.2148a6.3574 6.3574 0 1 0 6.3572 6.3574 6.3645 6.3645 0 0 0 -6.3572-6.3574z" />
    </g>
  );
};

export default withIcon(IconCircle);
